<template>
  <div :class="{ open: activeAside }" class="map-legend">
    <div class="title">
      <div class="cluster" />
      <span>{{ $t('employeesCluster') }}</span>
    </div>

    <div v-if="study.withWalkingTimes" class="title">
      <div class="dot orange" />
      <span>{{ $t('includedCollaborators') }}</span>
    </div>

    <div v-if="study.withWalkingTimes" class="title">
      <div class="dot grey" />
      <span>{{ $t('excludedCollaborators') }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MapLegend',

  computed: {
    ...mapGetters(['activeAside', 'study']),
  },
};
</script>

<style lang="scss" scoped>
.map-legend {
  display: flex;
  flex-direction: column;
  gap: 4px;

  position: absolute;
  bottom: 32px;
  left: 64px;

  background: white;
  padding: 6px 8px;
  border-radius: 2px;
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;

  transition: left 0.8s 0.1s;

  &.open {
    left: 334px;
  }

  .title {
    display: flex;
    align-items: center;
    gap: 8px;

    .cluster {
      width: 12px;
      height: 12px;
      background-size: 15px;
      background-position: center;
      background-image: url('../../assets/markerClusterer/m2.png');
    }

    .dot {
      width: 12px;
      height: 12px;
      border-radius: 6px;

      &.orange {
        background-color: #f7a61f;
      }

      &.grey {
        background-image: url('../../assets/grey-cross-circle.svg');
        background-size: 12px;
      }
    }
  }
}
</style>
